import React, { useEffect, useState, useMemo } from 'react';
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { DialogPdf } from '../../pures';
import { b64toBlob } from '../../../validators';

const DocumentPDF = (props) => {

    let {
        url,
        permissions,
        fileWasUpload64
    } = props
    const [urlPdf, setUrlPdf] = useState('')
    const [blobAWS, setBlobAWS] = useState("");
    const [fileSelected, setFileSelected] = useState('')
    const [blobUrl, setBlobUrl] = useState("");

    const pdfAWS = useMemo(() => <PdfReader useFullHeight className="pdfReader" url={urlPdf} awsURL showDownloadPDF={false} />, [urlPdf])
    const pdf = useMemo(() => <PdfReader useFullHeight className="pdfReader" file={fileSelected} isFile showDownloadPDF={false} src={`data:application/pdf;base64,${fileSelected}`}  ></PdfReader>, [fileSelected])

    useEffect(() => {
        if (fileWasUpload64) {
            const blob = b64toBlob(fileWasUpload64, "application/pdf");
            setBlobUrl(blob);
            setFileSelected(fileWasUpload64)
        }
    }, [fileWasUpload64]);

    useEffect(() => {
        if (!url) return
        setBlobAWS(url)
        setUrlPdf(url)
    }, [url])

    return (
        <>
            {
                fileWasUpload64 ? (
                    <>
                        <div className='documentPDF-container'>
                            {pdf}
                        </div>
                        <div className="documentPDF-pdf-btn">
                            <DialogPdf blobUrl={blobUrl} />
                        </div>
                    </>
                ) : (
                    <>
                        <div className='documentPDF-container'>
                            {pdfAWS}
                        </div>
                        <div className="documentPDF-pdf-btn">
                            <DialogPdf blobUrl={blobAWS} />
                        </div>
                    </>
                )
            }
        </>
    )
}

export default DocumentPDF